import React from 'react'
import NavItem from '../NavItem'

const MenuList: React.FC<PropType> = () => {
  const menus = [
    {
      code: 'home',
      link: '/',
      iconCode: 'home.svg'
    },
    {
      code: 'recent',
      link: '/recent/',
      iconCode: 'time.svg'
    },
    {
      code: 'new',
      link: '/new/',
      iconCode: 'new.svg'
    },
    {
      code: 'hot',
      link: '/hot/',
      iconCode: 'other.svg'
    }
  ]

  return (
    <>
      {menus.map(menu => {
        return <NavItem item={menu} key={menu.code} />
      })}
    </>
  )
}

interface PropType {}

export default React.memo(MenuList)
